import { useEffect, useReducer } from "react";
import { getAdvocateCode } from "lib/api";
import { useHasCurrentMembership } from "./useHasCurrentMembership";

type Action =
  | { type: "LOADING" }
  | { type: "ERROR" }
  | { type: "COMPLETE"; payload?: string };

interface State {
  loading: boolean;
  error: boolean;
  advocateCode?: string;
}

export const advocateCodeReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "LOADING":
      return {
        loading: true,
        error: false,
        advocateCode: undefined
      };
    case "ERROR":
      return {
        loading: false,
        error: true,
        advocateCode: undefined
      };
    case "COMPLETE":
      return {
        loading: false,
        error: false,
        advocateCode: action.payload
      };
    default:
      return {
        ...state
      };
  }
};

export const useAdvocateCode = (): State => {
  const [state, dispatch] = useReducer(advocateCodeReducer, {
    error: false,
    loading: false,
    advocateCode: undefined
  });

  const isMember = useHasCurrentMembership();

  useEffect(() => {
    if (!isMember) {
      dispatch({ type: "COMPLETE", payload: undefined });
      return;
    }
    dispatch({ type: "LOADING" });
    getAdvocateCode()
      .then((code) => {
        dispatch({
          type: "COMPLETE",
          payload: code
        });
      })
      .catch(() => {
        dispatch({ type: "ERROR" });
      });
  }, [isMember]);

  return { ...state };
};
